/**
 * `MOBILE_MONEY` et `COUNTER` sont les deux moyens proposes au client.
 * `CASH`, `CARD` et `OTHER` ne sont plus proposes : ils restent pour les
 * factures deja emises, qu'une facture figee interdit de reecrire.
 * Voir docs/adr/0012-paiement-verifie-avant-cloture.md.
 */
export const PAYMENT_METHODS = ['MOBILE_MONEY', 'COUNTER', 'CASH', 'CARD', 'OTHER'];
/**
 * Etats de la normalisation d'une facture aupres de l'e-MCF de la DGI.
 *
 * Chaque etat est ecrit en base avant l'appel suivant : une interruption laisse
 * toujours un etat qui dit ce qui est deja parti chez la DGI. `NORMALIZED`,
 * `REJECTED` et `UNCERTAIN` sont finaux pour la machine ; les deux derniers
 * attendent un humain.
 *
 * Voir docs/08-facturation-pdf.md, section 12, et docs/adr/0028.
 */
export const INVOICE_NORMALIZATION_STATUSES = [
    'PENDING',
    'SUBMITTED',
    'CONFIRMING',
    'NORMALIZED',
    'REJECTED',
    'UNCERTAIN',
];
//# sourceMappingURL=invoice.js.map